/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 28/07/13
 * Time: 09:23
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.controllers').controller('LoyaltyCardCtrl', ["$scope", "$dialog", "$timeout", "LoyaltyCardCategorySrv", "LoyaltyCardCategoryData", "LoyaltyCardCategory", "LoyaltyCardSrv",
    "LoyaltyCardData", "LoyaltyCard", "ImageData", "LoyaltyCardView", "LoyaltyCardCategoryView", "StyleData", "CategoryView",
    "CategoryData", "CustomerData", "$filter", "gettextCatalog",
    function ($scope, $dialog, $timeout, LoyaltyCardCategorySrv, LoyaltyCardCategoryData, LoyaltyCardCategory, LoyaltyCardSrv,
              LoyaltyCardData, LoyaltyCard, ImageData, LoyaltyCardView, LoyaltyCardCategoryView, StyleData, CategoryView,
              CategoryData, CustomerData, $filter, gettextCatalog) {
        $scope.dd =
            {
                view:
                    {
                        categoryRootView: null,
                        loyaltyCardsViewIndex: [],//Keep index
                        deletedCategoriesView: [],
                        deletedLoyaltyCardsView: [],
                        imagesView: [],
                        imagesViewFiltered: [],
                        styles: StyleData.styles,
                        displaySubConf: 1,
                        tab: 1,
                        subTab: 1,
                        displayError: false,  //Used  to display error message when user click on save,
                        selected: {
                            categoryView: null,
                            loyaltyCardView: null
                        },
                        edited:
                            {
                                categoryView: null,
                                loyaltyCardView: null,
                                loading: false,
                                editable: true
                            }
                    },
                flowConfig: {
                    target: '/rest/companyImageUpload',
                    method: 'octet',
                    query: {companyCode: $scope.ad.companyCode, type: 'loyaltyCard'},
                    maxChunkRetries: 1,
                    chunkRetryInterval: 5000,
                    simultaneousUploads: 4,
                    singleFile: true,
                    testChunks: false,
                    headers: {Authorization: $scope.ad.currentUser.token}
                }
            };

        $scope.$watch('ad.dataLoaded', function (newValue, oldValue) {
            if (newValue) {
                if (!$scope.ad.managerMode) {
                    $scope.goToDomain("planningPos", "dashboard");
                }
                $scope.dd.view.imagesView = ImageData.getActiveList("");
                $scope.dd.view.imagesViewFiltered = ImageData.getFilteredImages();
                $scope.dd.view.categoryRootView = new LoyaltyCardCategoryView(LoyaltyCardCategoryData.categoryRoot, LoyaltyCardCategoryData.getIndexOf(LoyaltyCardCategoryData.categoryRoot), null, $scope);// categoryRoot index  = 0
                $scope.dd.view.categoryRootView.label = "Racine"
                $scope.dd.view.selected.categoryView = $scope.dd.view.categoryRootView;

                var categories = LoyaltyCardCategoryData.getDeletedList();
                var parentCatView;
                for (var i = 0; i < categories.length; i++) {
                    if (categories[i].parentCategory)
                        parentCatView = $scope.getCategoryView(categories[i].parentCategory);
                    else
                        parentCatView = null;
                    $scope.dd.view.deletedCategoriesView.push(new LoyaltyCardCategoryView(categories[i], LoyaltyCardCategoryData.getIndexOf(categories[i]), parentCatView, $scope))
                }
                var loyaltyCards = LoyaltyCardData.getDeletedList();
                for (var i = 0; i < loyaltyCards.length; i++) {
                    if (loyaltyCards[i].parentCategory)
                        parentCatView = $scope.getCategoryView(loyaltyCards[i].parentCategory);
                    else
                        parentCatView = null;
                    $scope.dd.view.deletedLoyaltyCardsView.push(new LoyaltyCardView(loyaltyCards[i], LoyaltyCardData.getIndexOf(loyaltyCards[i]), parentCatView, $scope))
                }
            }
        });

        $scope.addLoyaltyCardViewIndex = function (loyaltyCardView) {
            $scope.dd.view.loyaltyCardsViewIndex.push(loyaltyCardView);
        };

        $scope.getCfgClass = function (confItem, className) {
            if (confItem == $scope.dd.view.displaySubConf)
                return className;
            return "";
        };

        $scope.getServiceView = function (service) {
            return $scope.dd.view.serviceCategoryRootView.getServiceView(service)
        }
//CATEGORY


        $scope.getCategoryView = function (category) {
            //Assume view index = model index
            var categoryView = $scope.dd.view.categoryRootView.getCategoryView(category)
            if (!categoryView) //must be deleted then instanciate it
            {
                var parentCategoryView = null;
                if (category.parentCategory)
                    parentCategoryView = this.getCategoryView(category.parentCategory)
                categoryView = new LoyaltyCardCategoryView(category, LoyaltyCardCategoryData.getIndexOf(category), parentCategoryView, this);

            }
            return categoryView;
        };
        $scope.createCategory = function (parentCategoryView) {
            if ($scope.dd.view.edited.categoryView && $scope.dd.view.edited.categoryView.isChanged()) {
                $scope.displayChangeMsg = true;
                return;
            }
            if ($scope.dd.view.edited.loyaltyCardView)
                if ($scope.dd.view.edited.loyaltyCardView.isChanged()) {
                    $scope.displayChangeMsg = true;
                    return;
                } else {
                    $scope.dd.view.edited.loyaltyCardView = null;
                }

            var categoryView = new LoyaltyCardCategoryView(null, -1, parentCategoryView, $scope);
            if (parentCategoryView) {
                if (parentCategoryView.image)
                    categoryView.setImage(parentCategoryView.image);

                $scope.dd.view.edited.categoryView = categoryView;
                parentCategoryView.addCategoryView(categoryView);
            }
        };
        $scope.setCurrentCategory = function (category) {
            if ($scope.dd.view.edited.categoryView && $scope.dd.view.edited.categoryView.isChanged()) {
                $scope.displayChangeMsg = true;
                return;
            }
            if ($scope.dd.view.edited.loyaltyCardView)
                if ($scope.dd.view.edited.loyaltyCardView.isChanged()) {
                    $scope.displayChangeMsg = true;
                    return;
                } else {
                    $scope.dd.view.edited.loyaltyCardView.hrSkillsView = null;
                    $scope.dd.view.edited.loyaltyCardView.prSkillsView = null;
                    $scope.dd.view.edited.loyaltyCardView = null;
                }

            if ($scope.dd.view.edited.categoryView)
                $scope.dd.view.edited.categoryView = null;

            $scope.dd.view.selected.categoryView = category;
        };
        $scope.setEditedCategory = function (categoryView) {
            if ($scope.dd.view.edited.categoryView && $scope.dd.view.edited.categoryView.isChanged()) {
                $scope.displayChangeMsg = true;
                return;
            }
            if ($scope.dd.view.edited.loyaltyCardView)
                if ($scope.dd.view.edited.loyaltyCardView.isChanged()) {
                    $scope.displayChangeMsg = true;
                    return;
                } else {
                    $scope.dd.view.edited.loyaltyCardView = null;
                }

            $scope.dd.view.edited.categoryView = categoryView;

            if ($scope.dd.view.tab > 2)
                $scope.dd.view.tab = 1;
        };
        $scope.saveEditedCategory = function () {
            if ($scope.dd.view.edited.categoryView)
                $scope.dd.view.edited.categoryView.updateModel();
            $scope.dd.view.edited.categoryView = null;
            $scope.displayChangeMsg = false;
        };
        $scope.cancelEditedCategory = function () {
            $scope.dd.view.edited.categoryView.reloadModel();
            $scope.dd.view.displayError = false;
            $scope.dd.view.edited.categoryView = null;
            $scope.displayChangeMsg = false;
        };
        $scope.afterRemoveCategory = function (category) {
            if (!category.parentCategory)//Remove from $scope
            {
                var index = $scope.categoryRoot.categories.indexOf(category);
                if (index != -1)
                    $scope.categoryRoot.categories.splice(index, 1);
                $scope.currentCategory = null;
            }
        };
        $scope.openDeletedCategoryViewConfirmDialog = function () {
            if ($scope.dd.view.edited.categoryView) {
                var opts = {
                    backdrop: true,
                    keyboard: true,
                    backdropClick: false,
                    templateUrl: '/partials/global/removeConfirm.html',
                    controller: 'DialogCtrl',
                    resolve: {
                        dialogsModel: function () {
                            var tableModel = [];
                            tableModel["label"] = $scope.dd.view.edited.categoryView.label;
                            return tableModel;
                        }
                    }
                };

                var d = $dialog.dialog(opts);
                d.open().then(function (result) {
                    if (result)
                        $scope.removeEditedCategory();
                });
            }
        };
        $scope.removeEditedCategory = function () {
            if ($scope.dd.view.edited.categoryView) {
                $scope.dd.view.edited.categoryView.removeModel();
                var parentCategoryView = $scope.dd.view.edited.categoryView.parentCategoryView;
                if (parentCategoryView)
                    parentCategoryView.removeCategoryView($scope.dd.view.edited.categoryView);
                $scope.dd.view.deletedCategoriesView.push($scope.dd.view.edited.categoryView);
                $scope.dd.view.edited.categoryView = null;
                $scope.displayChangeMsg = false;
            }

        };
        $scope.getClassForActiveCategory = function (category, className) {
            ////console.log("getClassForActive" + loyaltyCard.id);
            if (category === $scope.dd.view.edited.categoryView)
                return className;
            return "";
        };
        $scope.restoreCategory = function (categoryView) {
            if (categoryView) {
                if (categoryView.catIndex != -1)// retrieve old value from server
                    categoryView.restoreModel();
                var index = $scope.dd.view.deletedCategoriesView.indexOf(categoryView);
                if (index != -1) {
                    $scope.dd.view.deletedCategoriesView.splice(index, 1);
                    if (categoryView.parentCategoryView)
                        categoryView.parentCategoryView.addCategoryView(categoryView)
                }


            }

        };


// LoyaltyCard


        $scope.getClassForActiveLoyaltyCard = function (loyaltyCard, className) {
            ////console.log("getClassForActive" + loyaltyCard.id);
            if (loyaltyCard === $scope.dd.view.edited.loyaltyCardView)
                return className;
            return "";
        };
        $scope.createLoyaltyCard = function () {
            $scope.dd.view.edited.editable = true;
            if ($scope.dd.view.edited.categoryView)
                if ($scope.dd.view.edited.categoryView.isChanged()) {
                    $scope.displayChangeMsg = true;
                    return;
                } else
                    $scope.dd.view.edited.categoryView = null;

            if ($scope.dd.view.edited.loyaltyCardView && $scope.dd.view.edited.loyaltyCardView.isChanged()) {
                $scope.displayChangeMsg = true;
                return;
            }
            var categoryView = $scope.dd.view.selected.categoryView;
            if (categoryView.catIndex == -1) {
                var msg = gettextCatalog.getString("Vous devez sauver une première fois la catégorie pour pouvoir lui ajouter des cartes.");
                alert(msg + ".")
                return;
            }
            var newLoyaltyCardView = new LoyaltyCardView(null, -1, categoryView, $scope);
            categoryView.addLoyaltyCardView(newLoyaltyCardView);

            if (categoryView.image && categoryView.image !== null)
                newLoyaltyCardView.setImage(categoryView.image);

            $scope.setEditedLoyaltyCard(newLoyaltyCardView);
        };

        $scope.loyaltyCardClicked = function (loyaltyCardView) {
            const loyaltyCard = loyaltyCardView.getModel();
            const loyaltyCardId = loyaltyCard ? loyaltyCard.id : null;
            if (loyaltyCardId) {
                $scope.dd.view.edited.loading = true;
                LoyaltyCardSrv.editable(loyaltyCard.id).then(
                    () => {
                        $scope.dd.view.edited.editable = true;
                        $scope.setEditedLoyaltyCard(loyaltyCardView);
                    },
                    () => {
                        $scope.dd.view.edited.editable = false;
                        $scope.setEditedLoyaltyCard(loyaltyCardView);
                    });
            } else {
                $scope.setEditedLoyaltyCard(loyaltyCardView);
            }
        };

        $scope.updateSmsList = function (loyaltyCardView) {
            let loyaltyCardsLoading = gettextCatalog.getString("Chargement en cours...");
            $('#table-smsSent').replaceWith('<div id=\"table-smsSent\"><i class=\"fal fa-spinner fa-spin\"></i>' + loyaltyCardsLoading + '</div>');
            LoyaltyCardSrv.getSms(loyaltyCardView.getModel(),
                function (smsList) {
                    if (smsList && smsList.length > 0) {
                        smsList = $filter('orderBy')(smsList, 'sentDate');
                        loyaltyCardView.nbSmsSent = smsList.length;
                        smsList = $filter('orderBy')(smsList, 'sentDate');
                        var table = "<div id=\"table-smsSent\"><table class=\"table table-bordered fxb-table\" style=\"width: 100%\"><tr><th>Nb : " + smsList.length + "</th>" +
                            "<th>Date</th><th>Client</th><th>Mobile</th></tr>";
                        for (var i = 0; i < smsList.length; i++) {
                            var customerLabel = "";
                            if (smsList[i].customerId) {
                                var customer = CustomerData.getById(smsList[i].customerId)
                                if (customer)
                                    customerLabel = customer.firstName + ' ' + customer.lastName;

                            }
                            table += "<tr><td>" + (i + 1) + "</td><td>" + $filter('date')(smsList[i].sentDate, 'short') + "</td><td>" + customerLabel + "</td><td>" + smsList[i].sentTo + "</td></tr>"
                        }
                        table += "</table></div>";
                        $('#table-smsSent').replaceWith(table);
                    } else {
                        var noSmsSend = gettextCatalog.getString("Aucun sms envoyé.");
                        $('#table-smsSent').replaceWith("<div id=\"table-smsSent\">" + noSmsSend);
                    }

                });
        }
        $scope.setEditedLoyaltyCard = function (loyaltyCardView) {
            $scope.dd.view.edited.loading = false;
            if ($scope.dd.view.edited.categoryView) {
                if ($scope.dd.view.edited.categoryView.isChanged()) {
                    $scope.displayChangeMsg = true;
                    return;
                } else {
                    $scope.dd.view.edited.categoryView = null;
                }
            }
            if ($scope.dd.view.edited.loyaltyCardView && $scope.dd.view.edited.loyaltyCardView.isChanged()) {
                $scope.displayChangeMsg = true;
                return;
            }
            $scope.dd.view.edited.loyaltyCardView = loyaltyCardView;
            if ($scope.dd.view.tab == 6) {
                $scope.updateSmsList(loyaltyCardView);
            }
        };


        $scope.saveEditedLoyaltyCard = function () {
            if ($scope.dd.view.edited.loyaltyCardView) {
                $scope.dd.view.edited.loyaltyCardView.updateModel();
                $scope.dd.view.displayError = false;
                $scope.dd.view.edited.loyaltyCardView.hrSkillsView = null;
                $scope.dd.view.edited.loyaltyCardView.prSkillsView = null;
                $scope.dd.view.edited.loyaltyCardView = null;
                $scope.displayChangeMsg = false;
            }
        };
        $scope.cancelEditedLoyaltyCard = function () {
            $scope.dd.view.edited.loyaltyCardView.reloadModel();
            $scope.dd.view.displayError = false;
            $scope.dd.view.edited.loyaltyCardView = null;
            $scope.displayChangeMsg = false;
        };
        $scope.openDeletedLoyaltyCardViewConfirmDialog = function () {
            if ($scope.dd.view.edited.loyaltyCardView) {
                var opts = {
                    backdrop: true,
                    keyboard: true,
                    backdropClick: false,
                    templateUrl: '/partials/global/removeConfirm.html',
                    controller: 'DialogCtrl',
                    resolve: {
                        dialogsModel: function () {
                            var tableModel = [];
                            tableModel["label"] = $scope.dd.view.edited.loyaltyCardView.label;
                            return tableModel;
                        }
                    }
                };

                var d = $dialog.dialog(opts);
                d.open().then(function (result) {
                    if (result)
                        $scope.removeEditedLoyaltyCard();
                });
            }
        };
        $scope.removeEditedLoyaltyCard = function () {
            if ($scope.dd.view.edited.loyaltyCardView) {
                $scope.dd.view.edited.loyaltyCardView.removeModel();
                var parentCategoryView = $scope.dd.view.edited.loyaltyCardView.parentCategoryView;
                if (parentCategoryView)
                    parentCategoryView.removeLoyaltyCardView($scope.dd.view.edited.loyaltyCardView);
                $scope.dd.view.deletedLoyaltyCardsView.push($scope.dd.view.edited.loyaltyCardView);
                $scope.dd.view.edited.loyaltyCardView.hrSkillsView = null;
                $scope.dd.view.edited.loyaltyCardView.prSkillsView = null;
                $scope.dd.view.edited.loyaltyCardView = null;

                $scope.displayChangeMsg = false;
            }
        };
        $scope.restoreLoyaltyCard = function (loyaltyCardView) {
            if (loyaltyCardView) {
                if (loyaltyCardView.servIndex != -1)// retrieve old value from server
                    loyaltyCardView.restoreModel();
                var index = $scope.dd.view.deletedLoyaltyCardsView.indexOf(loyaltyCardView);
                if (index != -1) {
                    $scope.dd.view.deletedLoyaltyCardsView.splice(index, 1);
                    if (loyaltyCardView.parentCategoryView)
                        loyaltyCardView.parentCategoryView.addLoyaltyCardView(loyaltyCardView)
                }


            }

        };


//Assign image


        $scope.imageIsSelected = function (image) {
            if ($scope.dd.view.edited.loyaltyCardView) {
                if (!$scope.dd.view.edited.loyaltyCardView.companyImage && $scope.dd.view.edited.loyaltyCardView.image === image)
                    return true
            } else if (!$scope.dd.view.edited.categoryView.companyImage && $scope.dd.view.edited.categoryView.image === image)
                return true

            return false;
        };

        $scope.companyImageIsSelected = function (companyImage) {
            if ($scope.dd.view.edited.loyaltyCardView && $scope.dd.view.edited.loyaltyCardView.companyImage === companyImage)
                return true
            if ($scope.dd.view.edited.categoryView && $scope.dd.view.edited.categoryView.companyImage === companyImage)
                return true
            return false;
        };
        $scope.setImage = function (image) {
            if ($scope.dd.view.edited.loyaltyCardView) {
                if (image === $scope.dd.view.edited.loyaltyCardView.image) {
                    if ($scope.dd.view.edited.loyaltyCardView.image != null) {
                        $scope.dd.view.edited.loyaltyCardView.setImage(null);
                    } else {
                        $scope.dd.view.edited.loyaltyCardView.setImage($scope.dd.view.edited.loyaltyCardView.parentCategoryView.image);
                    }
                } else if (image != null) {
                    $scope.dd.view.edited.loyaltyCardView.setImage(image);
                } else {
                    $scope.dd.view.edited.loyaltyCardView.setImage($scope.dd.view.edited.loyaltyCardView.parentCategoryView.image);
                }
            }

            if ($scope.dd.view.edited.categoryView) {
                if (image === $scope.dd.view.edited.categoryView.image) {
                    if ($scope.dd.view.edited.categoryView.image != null) {
                        $scope.dd.view.edited.categoryView.setImage(null);
                    } else {
                        $scope.dd.view.edited.categoryView.setImage($scope.dd.view.edited.categoryView.parentCategoryView.image);
                    }
                } else if (image != null) {
                    $scope.dd.view.edited.categoryView.setImage(image);
                } else {
                    $scope.dd.view.edited.categoryView.setImage($scope.dd.view.edited.categoryView.parentCategoryView.image);
                }
            }
        };
        $scope.setCompanyImage = function (companyImage) {
            if ($scope.dd.view.edited.loyaltyCardView) {
                if (companyImage === $scope.dd.view.edited.loyaltyCardView.companyImage) {
                    if ($scope.dd.view.edited.loyaltyCardView.companyImage != null) {
                        $scope.dd.view.edited.loyaltyCardView.setCompanyImage(null);
                    } else {
                        $scope.dd.view.edited.loyaltyCardView.setCompanyImage($scope.dd.view.edited.loyaltyCardView.parentCategoryView.companyImage);
                    }
                } else if (companyImage != null) {
                    $scope.dd.view.edited.loyaltyCardView.setCompanyImage(companyImage);
                } else {
                    $scope.dd.view.edited.loyaltyCardView.setCompanyImage($scope.dd.view.edited.loyaltyCardView.parentCategoryView.companyImage);
                }
            }

            if ($scope.dd.view.edited.categoryView) {
                if (companyImage === $scope.dd.view.edited.categoryView.companyImage) {
                    if ($scope.dd.view.edited.categoryView.companyImage != null) {
                        $scope.dd.view.edited.categoryView.setCompanyImage(null);
                    } else {
                        $scope.dd.view.edited.categoryView.setCompanyImage($scope.dd.view.edited.categoryView.parentCategoryView.companyImage);
                    }
                } else if (companyImage != null) {
                    $scope.dd.view.edited.categoryView.setCompanyImage(companyImage);
                } else {
                    $scope.dd.view.edited.categoryView.setCompanyImage($scope.dd.view.edited.categoryView.parentCategoryView.companyImage);
                }
            }
        };

        $scope.getEditedItem = function () {
            return $scope.dd.view.edited.categoryView ? $scope.dd.view.edited.categoryView : ($scope.dd.view.edited.loyaltyCardView ? $scope.dd.view.edited.loyaltyCardView : null);
        };

    }]);



// WEBPACK FOOTER //
// ./js/controllers/pro/configuration/LoyaltyCardCtrl.js